import axios from 'axios';
import { serviceUrl } from '../../App';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export default class KanbanDesignService {
  public getKanbanDesign() {
    return axios.get(
      GetBackendUrlForGlobalFunctions() + `kanban/kanban-design`
    );
  }
  public addKanbanDesign(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      GetBackendUrlForGlobalFunctions() + `kanban/kanban-design/create`,
      obj,
      { headers }
    );
  }
  public editKanbanDesign(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      GetBackendUrlForGlobalFunctions() + `kanban/kanban-design/edit`,
      obj,
      { headers }
    );
  }
  public deleteKanbanDesign(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      GetBackendUrlForGlobalFunctions() + `kanban/kanban-design/delete`,
      obj,
      { headers }
    );
  }
}
